import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { motion } from 'framer-motion';

const ServiceComparison = () => {
  const { t } = useLanguage();
  const [activeTier, setActiveTier] = useState(0);

  const featureKeys = Object.keys(t.comparison.features);

  return (
    <Section id="comparison" bg="bg-brand-darker border-y border-brand-border/30">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <SectionHeading>{t.comparison.heading}</SectionHeading>
          <p className="text-xl text-brand-textMuted mt-6 max-w-2xl mx-auto">
            {t.comparison.subheading}
          </p>
        </div>

        {/* Comparison Dashboard */}
        <div className="bg-brand-card border border-brand-border rounded-3xl overflow-hidden shadow-2xl">
          <div className="grid lg:grid-cols-12">
            
            {/* Sidebar Selectors */}
            <div className="lg:col-span-4 border-b lg:border-b-0 lg:border-r border-brand-border bg-brand-dark/40 p-6 md:p-8">
              <h3 className="text-sm font-bold uppercase tracking-widest text-brand-accent mb-8">
                {t.comparison.cta}
              </h3>
              <div className="space-y-4">
                {t.comparison.tiers.map((tier, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveTier(idx)}
                    className={`w-full text-left p-5 rounded-xl transition-all duration-300 border ${
                      activeTier === idx 
                        ? 'bg-brand-accent/10 border-brand-accent/40 text-white' 
                        : 'bg-transparent border-transparent text-brand-textMuted hover:bg-brand-card hover:border-brand-border'
                    }`}
                  >
                    <div className="font-bold text-lg mb-1">{tier.name}</div>
                    <div className={`text-xs font-semibold uppercase tracking-wider ${activeTier === idx ? 'text-brand-accent' : 'text-brand-textMuted/60'}`}>
                      {tier.focus}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Feature Visualization */}
            <div className="lg:col-span-8 p-8 md:p-12 bg-brand-card">
              <motion.div
                key={activeTier}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4 }}
              >
                <div className="mb-10">
                  <h3 className="text-3xl font-bold text-brand-textHeading mb-4">
                    {t.comparison.tiers[activeTier].name}
                  </h3>
                  <p className="text-brand-text leading-relaxed">
                    {t.comparison.tiers[activeTier].desc}
                  </p>
                </div>

                <div className="space-y-8">
                  {featureKeys.map((key, i) => {
                    const value = t.comparison.tiers[activeTier].values[i];
                    return (
                      <div key={key}>
                        <div className="flex justify-between items-end mb-2">
                          <span className="text-sm font-bold text-brand-textHeading">
                            {t.comparison.features[key]}
                          </span>
                          <span className="text-xs font-medium text-brand-accent">
                            {value}%
                          </span>
                        </div>
                        <div className="h-2 bg-brand-dark rounded-full overflow-hidden border border-brand-border/50">
                          <motion.div
                            initial={{ width: 0 }}
                            animate={{ width: `${value}%` }}
                            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 * i }}
                            className="h-full bg-gradient-to-r from-brand-accent/60 to-brand-accent shadow-[0_0_10px_rgba(217,119,6,0.3)]"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </motion.div>
            </div>

          </div>
        </div>
      </div>
    </Section>
  );
};

export default ServiceComparison;